<template>
  <a
      :href="url"
      v-if="isShow"
      class="back-home"
      ref="moveBtn"
      @mousedown="down"
      @touchstart="down"
      @mousemove="move"
      @touchmove="move"
      @mouseup="end"
      @touchend="end"
      @touchcancel="end"
  >
  </a>
</template>

<script>
import {env} from "@/utils/commons"
import {complete,baseURL} from "@/utils/url"
import {sysVariable} from "@/utils/sys-variable"
export default {
  data() {
    return {
      url:'',
      flags: false,
      position: {
        x: 0,
        y: 0
      },
      active: 0,
      nx: "",
      ny: "",
      dx: "",
      dy: "",
      xPum: "",
      yPum: "",
      isShow: env.miniProgram,
      moveBtn: {}
    };
  },
  mounted() {
    this.moveBtn = this.$refs.moveBtn;
    sysVariable('miniProgramHomeUrl')
         .then(resp => this.url = complete(resp))
  },

  methods: {
    showActive(num) {
      this.active = num;
    },
    mouseleave(num) {
      this.active = num;
    },
    goUrl() {
      return baseURL;
    },
    // 实现移动端拖拽
    down() {
      this.flags = true;
      var touch;
      if (event.touches) {
        touch = event.touches[0];
      } else {
        touch = event;
      }
      this.position.x = touch.clientX;
      this.position.y = touch.clientY;
      this.dx = this.moveBtn.offsetLeft;
      this.dy = this.moveBtn.offsetTop;
    },
    move() {
      if (this.flags) {
        var touch;
        if (event.touches) {
          touch = event.touches[0];
        } else {
          touch = event;
        }
        this.nx = touch.clientX - this.position.x;
        this.ny = touch.clientY - this.position.y;
        this.xPum = this.dx + this.nx;
        this.yPum = this.dy + this.ny;
        var clientWidth = document.documentElement.clientWidth;
        var clientHeight = document.documentElement.clientHeight;
        if (
            this.xPum > 0 &&
            this.xPum < clientWidth - this.moveBtn.offsetWidth
        ) {
          this.moveBtn.style.left = this.xPum + "px";
        }
        if (
            this.yPum > 0 &&
            this.yPum < clientHeight - this.moveBtn.offsetHeight
        ) {
          this.moveBtn.style.top = this.yPum + "px";
        }

        //阻止页面的滑动默认事件
        document.addEventListener("touchmove", this.handler, {
          passive: false
        });
      }
    },
    //鼠标释放时候的函数
    end() {
      this.flags = false;
      document.addEventListener("touchmove", this.handler, {
        passive: false
      });
    },
    handler() {
      if (this.flags) {
        event.preventDefault();
      } else {
        return true;
      }
    }
  },
  destroyed(){
    document.removeEventListener('touchmove', this.handleScroll)
  }
};
</script>

<style lang="scss" scoped>
.back-home {
  width: 50px;
  height: 50px;
  position: fixed;
  //top: calc(80vh);  // 初始位置
  right: 20px;
  bottom: 166px;
  border-radius: 50px;
  z-index: 99999;
  background: rgba(255, 255, 255, .6) url("../assets/image/back-home/back-home.png") no-repeat center/contain;
  background-size: 30px;
  border: 2px solid #ccc;
  box-sizing: border-box;
  user-select: none;

}
</style>